import { BALANCE_FETCH_BY_EMP_ERROR, BALANCE_FETCH_BY_EMP_LOADING, BALANCE_FETCH_BY_EMP_SUCCESS, BALANCE_FETCH_BY_YEAR_ERROR, BALANCE_FETCH_BY_YEAR_LOADING, BALANCE_FETCH_BY_YEAR_SUCCESS, BALANCE_FETCH_ERROR, BALANCE_FETCH_LOADING, BALANCE_FETCH_SUCCESS, BALANCE_GET_ERROR, BALANCE_GET_LOADING, BALANCE_GET_SUCCESS, RESET_RESULT } from "../types"

const initialState={
    loading:false,
    page_loading:false,
    result:[],
    error:"",
    
}
const leaveBalanceReducer=(state=initialState,action)=>{
    switch(action.type){
          case BALANCE_FETCH_LOADING:
              return {
                ...state,
                loading: action.payload,
                error: "",
              };
            case BALANCE_FETCH_SUCCESS:
              return {
                ...state,
                loading: false,
                result: action.payload,
              };
            case BALANCE_FETCH_ERROR:
              return {
                ...state,
                loading: false,
                result: [],
                error: action.payload,
              };
        case BALANCE_GET_LOADING:
            return{
                ...state,
                page_loading:action.payload,
                error:""
            };
        case BALANCE_GET_SUCCESS:
            return{
                ...state,
                loading:false,
                result:action.payload
            }
        case BALANCE_GET_ERROR:
            return{
                ...state,
                loading:false,
                error:action.payload
            }
        case BALANCE_FETCH_BY_YEAR_SUCCESS:
            return{
                ...state,
                loading:false,
                result:action.payload
            }
        case BALANCE_FETCH_BY_YEAR_ERROR:
            return{
                ...state,
                loading:false,
                result:[],
                error:action.payload
            }
        case BALANCE_FETCH_BY_YEAR_LOADING:
            return{
                ...state,
                loading:action.payload,
                error:""
            }
        case BALANCE_FETCH_BY_EMP_SUCCESS:
            return{
                ...state,
                loading:false,
                result:action.payload
            }
        case BALANCE_FETCH_BY_EMP_ERROR:
            return{
                ...state,
                loading:false,
                result:[],
                error:action.payload
            }
        case BALANCE_FETCH_BY_EMP_LOADING:
            return{
                ...state,
                page_loading:action.payload,
                error:""
            }
        case RESET_RESULT:
            return{
                ...state,
                result:[],
                error:""
            }

        default:
            return state
    }
};
export default leaveBalanceReducer;